import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import styled, { css } from 'styled-components';
import Button from './Button';
import Box from './Box';
const SegmentedControlContainer = styled(Box).withConfig({
  displayName: "SegmentedControl__SegmentedControlContainer",
  componentId: "sc-14buivr-0"
})(["&&{display:", ";gap:3px;padding:3px;border-radius:20px;background-color:", ";", " > .bp4-button{border-radius:20px;}> .bp4-button:not(.bp4-minimal):not(.bp4-intent-primary){background-color:", ";box-shadow:", ";}> .bp4-button.bp4-minimal{color:", ";}> .bp4-button.bp4-minimal:disabled{color:", ";}}"], ({
  $inline
}) => $inline ? 'inline-flex' : 'flex', ({
  theme
}) => theme.name === 'dark' ? '#3e3e3e' : '#f6f7f9', ({
  $fill
}) => $fill && css(["width:100%;> .bp4-button{flex-grow:1;}"]), ({
  theme
}) => theme.name === 'dark' ? 'rgb(37, 37, 37)' : '#ffffff', ({
  theme
}) => theme.name === 'dark' ? 'rgb(255 255 255 / 8%) 0px 0px 0px 1px, rgb(0 0 0 / 0%) 0px 1px 1px' : '0 0 0 1px rgba(17, 20, 24, 0.1), 0 1px 1px rgba(17, 20, 24, 0.12)', ({
  theme
}) => theme.name === 'dark' ? 'rgba(171, 179, 191, 1)' : 'rgba(95, 107, 124, 1)', ({
  theme
}) => theme.name === 'dark' ? 'rgba(171, 179, 191, 0.6)' : 'rgba(95, 107, 124, 0.6)');
const SegmentedControl = ({
  options,
  value,
  onChange,
  fill,
  inline,
  small,
  large,
  disabled,
  role = 'radiogroup',
  ...boxProps
}) => /*#__PURE__*/React.createElement(SegmentedControlContainer, _extends({
  $fill: fill,
  $inline: inline,
  role: role
}, boxProps), options.map(option => {
  const isActive = value === option.value;
  return /*#__PURE__*/React.createElement(Button, {
    key: option.value,
    text: option.label,
    minimal: !isActive,
    active: isActive,
    small: small,
    large: large,
    disabled: disabled || option.disabled,
    onClick: () => onChange?.(option.value),
    "aria-checked": isActive,
    role: role === 'radiogroup' ? 'radio' : 'button'
  });
}));
export default SegmentedControl;